import React from 'react';
import { LinkButton } from '../ui/Button';
import { owner, values } from '../../data/site';
export function About() {
  return <section id="om" className="scroll-mt-24 border-y border-line bg-canvas-deep" data-id="element-247" data-mp="oqci2axj4eg1">
      <div className="mx-auto max-w-content px-5 py-16 md:py-24 lg:px-8" data-id="element-248" data-mp="12pvliqfeb1m0">
        <div className="grid items-start gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-249" data-mp="ypl84sp9x8x4">
          {/* Portrættet står øverst på mobil, til venstre på desktop. */}
          <figure className="overflow-hidden rounded-card border border-line bg-white" data-id="element-250" data-mp="axmtbyqm8vf8">
            <img src={owner.portrait} alt={`${owner.name}, indehaver af LYKKEVÆRK`} className="aspect-[4/5] w-full object-cover object-top" data-id="element-251" data-mp="62h68wlh9apk" />
            <figcaption className="border-t border-line px-5 py-4" data-id="element-252" data-mp="f01a8daq5l3v">
              <p className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-253" data-mp="3ng2tvsbdmnix">{owner.name}</p>
              <p className="mt-0.5 text-sm text-ink-muted" data-id="element-254" data-mp="3jehm2ldp8zfl">{owner.role}</p>
            </figcaption>
          </figure>

          <div data-id="element-255" data-mp="338p6vgbykl0k">
            <p className="font-display text-lg font-bold tracking-tight text-accent-deep" data-id="element-256" data-mp="3375qlpqay9ys">
              Om LYKKEVÆRK
            </p>
            <h2 className="mt-2 font-display text-[clamp(2rem,5.5vw,3.5rem)] font-bold leading-[1.03] tracking-tight text-ink" data-id="element-257" data-mp="3czbi6ycn6pdg">
              Mød personen bag LYKKEVÆRK
            </h2>

            <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink-soft md:text-[19px]" data-id="element-258" data-mp="2kadzwv8fkskp">
              {owner.intro.map(paragraph => <p key={paragraph} data-id="element-259" data-mp="2pa8qsys7hi5r">{paragraph}</p>)}
            </div>

            <ul className="mt-10 grid gap-x-8 gap-y-5 border-t border-line pt-8 sm:grid-cols-2" data-id="element-260" data-mp="2u7imuxa3os2k">
              {values.map(value => <li key={value.title} data-id="element-261" data-mp="2z5k55fzpcncz">
                  <h3 className="font-display text-base font-bold tracking-tight text-ink" data-id="element-262" data-mp="9iulevdvy4ur">
                    {value.title}
                  </h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-263" data-mp="efl1vjtlr2gp">
                    {value.description}
                  </p>
                </li>)}
            </ul>

            <LinkButton href="#kontakt" size="md" className="mt-10" data-id="element-264" data-mp="25l7rru50y5sr">
              Kontakt mig
            </LinkButton>
          </div>
        </div>
      </div>
    </section>;
}